/**
 * DfE Academic-cohort fallback for IB (or near-empty GCE A level) sixth forms.
 * Loader sets version like "Revised · Academic (IB)" — see KS5_ACADEMIC_FALLBACK_URNS.
 */
export function isKs5AcademicIbFallback(row) {
  const v = String(row?.version || "").toLowerCase();
  return v.includes("academic (ib)") || v.includes("academic(ib)");
}
